import { render, staticRenderFns } from "./EndorsementProposalContract.vue?vue&type=template&id=8d58b0b0"
import script from "./EndorsementProposalContract.vue?vue&type=script&lang=js"
export * from "./EndorsementProposalContract.vue?vue&type=script&lang=js"
import style0 from "./EndorsementProposalContract.vue?vue&type=style&index=0&id=8d58b0b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports